import React, { ReactNode } from 'react';
import styled from 'styled-components';
import { Typography } from '@mui/material';
import ContentWrapper from '../StyledComponents/ContentWrapper';

const SectionHeaderContainer = styled.div<{
  $padding?: string;
  $containerPadding?: string;
  $margin?: string;
  $pageHeader?: boolean;
  $addGradient?: boolean;
}>`
  ${(props) =>
    props.$pageHeader &&
    `
    background: ${props.theme.headerGradient};
    padding: 3.5rem 1rem 1.5rem;
    margin: -1rem;
    min-height: 10rem;
  `}

  ${(props) => props.$padding && `padding: ${props.$padding};`}
  ${(props) => props.$margin && `margin: ${props.$margin};`}
  ${(props) => props.$addGradient && `background: ${props.theme.headerGradient};`}

  ${(props) =>
    props.$pageHeader &&
    `
    padding: 2.5rem 1rem 2.5rem;
    background: ${props.theme.headerGradient};
  `}
  
  display: flex;
  justify-content: space-between;
  align-items: center;

  .MuiContainer-root {
    ${(props) => props.$containerPadding && `padding: ${props.$containerPadding};`}
  }
`;

const Title = styled(Typography)<{ $pageHeader?: boolean; $bold?: boolean }>`
  font-size: 1.5rem;

  ${(props) => props.$pageHeader && 'font-size: 2rem;'}
  ${(props) => props.$bold && 'font-weight: 500;'}
`;

type Props = {
  title?: string | ReactNode;
  actions?: ReactNode;
  pageHeader?: boolean;
  padding?: string;
  containerPadding?: string;
  margin?: string;
  addGradient?: boolean;
  bold?: boolean;
  alignItems?: string;
};

const SectionHeader = ({
  title,
  actions,
  pageHeader,
  padding,
  margin,
  addGradient,
  bold,
  containerPadding,
  alignItems = 'center',
}: Props) => {
  return (
    <SectionHeaderContainer
      $padding={padding}
      $containerPadding={containerPadding}
      $margin={margin}
      $addGradient={addGradient}
      $pageHeader={pageHeader}
    >
      <ContentWrapper
        sx={{ display: 'flex', justifyContent: 'space-between', alignItems, position: 'relative' }}
      >
        <Title variant='h2' $pageHeader={pageHeader} $bold={bold}>
          {title}
        </Title>
        <span>{actions}</span>
      </ContentWrapper>
    </SectionHeaderContainer>
  );
};

export default SectionHeader;
